const useCpuPlay = () => {

    const messageToWorker = (currentBoard, cpu) => {
        return new Promise((resolve, reject) => {
            const worker = new Worker(new URL('./worker.js', import.meta.url));
            worker.postMessage(JSON.stringify({
                board: currentBoard,
                optimizingPlayer: false,
                cpu: cpu,
                depth: 8
            }));

            worker.onmessage = (e) => {
                console.log(e.data)
                resolve(e.data);
            };

            worker.onerror = (e) => {
                reject(e);
            };
        });
    };

    const getCpuColumnPlay = async (grid, cpu) => {
        let result = await messageToWorker(grid, cpu)
        return result.column
    }

    return {
        getCpuColumnPlay
    }

}

export { useCpuPlay }